<!-- <app-stanc-loader></app-stanc-loader> -->

<div class="row m-0 h-100 login_container">

    <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 LoginBg setPadding ">
      <div class="row m-0 h-100 login">

        <div class="row_tab">
          <app-header></app-header>
          <div class="mainform">
            <div class="title col-12 align-self-center text-center">
              <img src="assets/images/warning-board.png">
              <h3 class="mb-4">Link Expired </h3>
              <h4>Please contact StandardC admin for further assistance.</h4>
              <!-- <button mat-raised-button color="primaryCus" (click)='ResendEmail()'>Resend Email</button> -->
            </div>

          </div>
        </div>
        <div class="col-12">
        <app-footer></app-footer>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-md-5 col-lg-5 col-xl-5 pos-rel welcomeBgNew h-100">
      <app-sidescreen></app-sidescreen>

    </div>
  </div>
